import React from "react";
import { Modal, Box, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import CheckIcon from "../../../assets/images/icons/catering-icons/check.svg";
import zIndex from "@mui/material/styles/zIndex";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 335,
  height: 215,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: "10px",
  textAlign: "center",
};

export const ProcessingModal = ({ open }) => {
  return (
    <Modal open={open} closeAfterTransition>
      <Box sx={style}>
        <div className="flex items-center justify-center flex-col h-full w-full">
          <CircularProgress size={45} thickness={4} sx={{ color: "#238856", mb: 2 }} />
          <p className="text-sm font-medium text-[#414651] mt-4">Extracting Receipt...</p>
        </div>
      </Box>
    </Modal>
  );
};

ProcessingModal.propTypes = {
  open: PropTypes.any,
};

// SUCCESS MODAL
export const SuccessModal = ({ open, goBack }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    maxWidth: "400px",
    bgcolor: "#fff",
    boxShadow: 10,
    p: "24px",
    borderRadius: "12px",
    "@media (max-width:767px)": {
      width: "90%",
      padding: `18px`,
    },
  };
  return (
    <Modal open={open}>
      <Box sx={style}>
        <div>
          <div className="flex items-center justify-center mb-5">
            <img className="w-[56px] h-[56px]" src={CheckIcon} />
          </div>
          {/* Modal Title */}
          <h2 className="text-lg text-center font-semibold text-gray-900 mb-2">Receipt added!</h2>
          {/* Modal Description */}
          <p className="text-[#535862] text-sm text-center mb-8">
            Your receipt has been added successfully. You will be notified if you qualify for a
            reward.
          </p>

          {/* BACK AND NEXT BTN  */}
          <div className="flex gap-2">
            <MDButton
              fullWidth
              variant="outlined"
              color="black"
              sx={{
                borderRadius: "8px",
                padding: "10px",
                textTransform: "none",
                border: "1px solid #D0D5DD",
                textDecoration: "lowercase",
                fontSize: 14,
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              }}
            >
              <Link to="/order-history">View Order</Link>
            </MDButton>

            <MDButton
              type="submit"
              sx={{ textTransform: "none", fontSize: 14 }}
              fullWidth
              onClick={goBack}
              variant="contained"
              color="success"
            >
              Okay
            </MDButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

SuccessModal.propTypes = {
  open: PropTypes.any,
  goBack: PropTypes.any,
};
